module.exports = __webpack_public_path__ + "graphics/02.ckh.c0e1ebdceb774e7fa242fd17a6f681de.png";